import { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'

import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

type PasswordInputProps = React.ComponentProps<typeof Input>

const PasswordInput = ({ className, ...props }: PasswordInputProps) => {
    const [visible, setVisible] = useState(false)

    return (
        <div className="relative">
            <Input
                type={visible ? 'text' : 'password'}
                className={cn('pr-12', className)}
                {...props}
            />
            <button
                type="button"
                onClick={() => setVisible(prev => !prev)}
                className="absolute inset-y-0 right-4 flex items-center text-[#99A0AE] transition-colors hover:text-[#0C1324]"
                aria-label={visible ? 'Hide password' : 'Show password'}
            >
                {visible ? (
                    <EyeOff className="h-4 w-4" />
                ) : (
                    <Eye className="h-4 w-4" />
                )}
            </button>
        </div>
    )
}

export default PasswordInput
